import React from 'react';
import { FormField, IFormField } from './FormField';
import { Input } from 'alurkerja-ui';

export const DateRange: React.FC<IFormField> = props => {
  return (
    <FormField
      className={''}
      {...props}
      render={({ field }) => {
        const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>, type: 'from' | 'to') => {
          const currentValue = field.value?.split(',') || ['', ''];
          const newValue = type === 'from' ? [e.target.value, currentValue[1]] : [currentValue[0], e.target.value];
          field.onChange(`${newValue[0] || ''},${newValue[1] || ''}`);
        };

        const [fromDate, toDate] = field.value?.split(',') || ['', ''];

        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            <Input
              id={`${props.name}-from`}
              defaultValue={fromDate}
              onChange={(e) => handleDateChange(e, 'from')}
              type={'date'}
              disabled={props.disabled}
              placeholder={`${props.placeholder} From`}
              step={undefined}
              max={toDate ? toDate : '2100-01-01'}
            />

            <Input
              id={`${props.name}-to`}
              defaultValue={toDate}
              onChange={(e) => handleDateChange(e, 'to')}
              type={'date'}
              disabled={props.disabled}
              placeholder={`${props.placeholder} To`}
              step={undefined}
              min={fromDate ? fromDate : '1900-01-01'}
            />
          </div>
        );
      }}
    />
  );
};